
/* eslint-disable */

import { mapGetters } from 'vuex';
import toast from '@/services/toast';
var $ = window.jQuery = require('jquery');
export default {
  name: 'q-ans-add-screen',
  components: {},
  props: [],
  data() {
    return {
      QuizList:null,
      quizDetailsEdit:null,
      quizData:[{
        quizId:''
      }],
      submitted:false,
      questionData:[{
        content:'',
      }],
      quizQuesDetails:null,
      radio_option:'',
      content1:'',
      is_correct1:false,
      content1_isValid:false,
      index1:1,
      content2:'',
      is_correct2:false,
      index2:2,
      content3:'',
      is_correct3:false,
      index3:3,
      content4:'',
      is_correct4:false,
      index4:4,
      content:'',
      is_correct:'',
      index:'',
      positive_points:'',
      negative_points:'',
      difficulty_level:'',
      estimated_solve_time:'',
      qBankInfo:null,
      qBankName:'',
      apiLoaderForQbanks:false
    }
  },
  computed: {
  },
  mounted() {
    this.quizData.quizId = this.$route.params.qbankId;
    this.createEditor();
    this.getQbankInfoByIdMethod();
  },
  methods: {
    getQbankInfoByIdMethod(){
      this.apiLoaderForQbanks = true
      this.$store.dispatch('getQBankInfoByIdAction', {id:this.$route.params.qbankId}).then((res) => {
        this.qBankInfo = res.data.data.results
        this.qBankName = this.qBankInfo.name
        this.apiLoaderForQbanks = false
      })
    },
    createEditor() {
      CKEDITOR.replace('Questioncontent',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['Questioncontent'].on('change', () => {
        var content1Length = CKEDITOR.instances['Questioncontent'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #Questioncontent').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #Questioncontent').removeClass('is-invalid')
          this.questionData.content = CKEDITOR.instances['Questioncontent'].getData()
        }else{
          $('.custom_editor_for_option #Questioncontent').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #Questioncontent').addClass('is-invalid')
          this.questionData.content = ''
        }
      })
      CKEDITOR.replace('content1',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content1'].on('change', () => {
        var content1Length = CKEDITOR.instances['content1'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #content1').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content1').removeClass('is-invalid')
          this.content1 = CKEDITOR.instances['content1'].getData()
        }else{
          $('.custom_editor_for_option #content1').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content1').addClass('is-invalid')
          this.content1 = ''
        }
      })
      CKEDITOR.replace('content2',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content2'].on('change', () => {
        var content2Length = CKEDITOR.instances['content2'].getData().replace(/<[^>]*>/gi, '').length;
        if(content2Length > 0){
          $('.custom_editor_for_option #content2').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content2').removeClass('is-invalid')
          this.content2 = CKEDITOR.instances['content2'].getData()
        }else{
          $('.custom_editor_for_option #content2').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content2').addClass('is-invalid')
          this.content2 = ''
        }
      })
      CKEDITOR.replace('content3',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content3'].on('change', () => {
        var content3Length = CKEDITOR.instances['content3'].getData().replace(/<[^>]*>/gi, '').length;
        if(content3Length > 0){
          $('.custom_editor_for_option #content3').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content3').removeClass('is-invalid')
          this.content3 = CKEDITOR.instances['content3'].getData()
        }else{
          $('.custom_editor_for_option #content3').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content3').addClass('is-invalid')
          this.content3 = ''
        }
      })
      CKEDITOR.replace('content4',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content4'].on('change', () => {
        var content4Length = CKEDITOR.instances['content4'].getData().replace(/<[^>]*>/gi, '').length;
        if(content4Length > 0){
          $('.custom_editor_for_option #content4').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content4').removeClass('is-invalid')
          this.content4 = CKEDITOR.instances['content4'].getData()
        }else{
          $('.custom_editor_for_option #content4').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content4').addClass('is-invalid')
          this.content4 = ''
        }
      })
    },
    validateCreateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let qData = {
            question_bank: this.$route.params.qbankId,
            content: this.questionData.content,
            estimated_solve_time:this.estimated_solve_time
          }
          this.$store.dispatch('postQuestionDataAction', qData).then((res) => {
            let questionId = res.data.data.results.id;
            if(this.radio_option == 'option1'){
              this.is_correct1 = true
            }
            if(this.radio_option == 'option2'){
              this.is_correct2 = true
            }
            if(this.radio_option == 'option3'){
              this.is_correct3 = true
            }
            if(this.radio_option == 'option4'){
              this.is_correct4 = true
            }
            let data = {
              options:[{
                content:this.content1,
                question:questionId,
                is_correct: this.is_correct1,
                index: this.index1
              },
              {
                content:this.content2,
                question:questionId,
                is_correct:this.is_correct2,
                index:this.index2
              },
              {
                content:this.content3,
                question:questionId,
                is_correct:this.is_correct3,
                index:this.index3
              },
              {
                content:this.content4,
                question:questionId,
                is_correct:this.is_correct4,
                index:this.index4
              }],
            }
            for (let i = 0; i < data.options.length; i++) {
              this.$store.dispatch('postAnsOptionDataAction',  data.options[i])
              .then((res) => {
                if(i == 3){
                  toast.success(res.data.msg || "Request has been successfully submitted");      
                  this.$router.push('/staff/employee/interview/qbank/question-answer/list/' + this.quizData.quizId)
                  this.submitted = false;
                }
              })
            }
          })
          return
        }
      });
    },
  },
  beforeMount() {
  },
  watch: {
  },
}